import { Routes } from '@angular/router';
import { errorHandlerGuard } from '@core/guards/error-handler.guard';
import { oktaCustomChildGuard } from '@core/guards/okta-custom.guard';
import { termsAndConditionsGuard } from '@core/guards/terms-and-conditions.guard';
import { OktaCallbackWrapperComponent } from '@auth/pages/login/okta-callback-wrapper.component';
import { ExternalOktaCallbackWrapperComponent } from '@auth/pages/login/external-okta-callback-wrapper.component';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('@auth/auth.routes').then((m) => m.routes),
  },
  {
    path: 'login/callback',
    component: OktaCallbackWrapperComponent,
    canActivate: [errorHandlerGuard],
  },
  {
    path: 'login/external-callback',
    component: ExternalOktaCallbackWrapperComponent,
  },
  {
    path: '',
    loadComponent: () =>
      import('@layouts/app-layout/app-layout.component').then((m) => m.AppLayoutComponent),
    canActivateChild: [oktaCustomChildGuard, termsAndConditionsGuard],
    children: [
      {
        path: 'engagements',
        loadChildren: () =>
          import('@engagements/engagements.routes').then((m) => m.ENGAGEMENTS_ROUTES),
      },
      { path: '', redirectTo: 'engagements', pathMatch: 'full' },
    ],
  },
  {
    path: '**',
    redirectTo: '/auth/login',
    pathMatch: 'full',
  },
];
